var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-simple', {
    attrs: {
      "title": "report.thgMeterReading.title"
    }
  }, [!_vm.loading ? _c('thg-meter-reading-form', {
    attrs: {
      "loading": _vm.loading,
      "chargingStationId": _vm.meterReading.meterReading.chargingStationId,
      "detail": ""
    },
    on: {
      "save": _vm.save
    },
    model: {
      value: _vm.meterReading,
      callback: function callback($$v) {
        _vm.meterReading = $$v;
      },
      expression: "meterReading"
    }
  }) : _c('v-skeleton-loader', {
    attrs: {
      "type": "article, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }